<template>
  <div class="contenedor-cpanel contenedor-mentorias">
    <BaseNotification2
      v-if="store.status.msg != null"
      :type="store.status.type"
      :text="store.status.msg"
      :closable="store.status.closable"
      @close="borrarNotificacion()"
    />
    <div class="contenedor-titulo">
      <h1>Mentorías</h1>
      <div class="barra"></div>
    </div>
    <div class="contenedor_boton_crear_mentor">
      <router-link to="/crear-mentoreado" class="boton-crear-mentor">Crear Mentoreado</router-link>
      <a href="https://asociacioniyengar.com.ar/pdf/MODELO_CARTA_DE_RECOMENDACION.docx" target="_blank" class="boton-crear-mentor">
        Descargar Carta de Recomendación
      </a>
    </div>
    <BaseLoader
      v-if="cargando"
    />
    <div class="contenedor_tabla_mentoria" v-else>
      <h2>Mentorías en Curso</h2>
      <p v-if="this.mentoriasAbiertas.length == 0" class="no-resultado-mentorias">No se encontraron resultados</p>
      <div class="contenedor_socios_lista tabla-mentorias" v-else>
        <table id="tabla-anotados-lista">
          <thead>
            <th class="column_1">Mentoreado</th>
            <th class="column_1">Fecha de Inicio</th>
            <th class="column_7">Condición AAYI</th>
            <th class="column_6">Examen</th>
            <th class="column_4"></th>
          </thead>
          <tbody>
            <MentoriasAbiertasListaItem
              v-for="mentor in mentoriasAbiertas"
              :mentor="mentor"
              :key="mentor.mentoria_id"
              @refrescar="refrescar"
            ></MentoriasAbiertasListaItem>
          </tbody>
        </table>
      </div>
    </div>
    <BaseLoader
        v-if="cargando2"
      />
    <div class="contenedor_tabla_mentoria" v-else>
      <h2>Mentorías Finalizadas</h2>
      <p v-if="this.mentoriasCerradas.length == 0" class="no-resultado-mentorias">No se encontraron resultados</p>
      <div class="contenedor_socios_lista tabla-mentorias" v-else>
        <table id="tabla-anotados-lista">
          <thead>
            <th class="column_1">Nombre</th>
            <th class="column_1">Fecha de Inicio</th>
            <th class="column_1">Fecha de Finalización</th>
            <th class="column_5">Observaciones</th>
            <th class="column_4"></th>
          </thead>
          <tbody>
            <MentoriasCerradasListaItem
              v-for="mentoria in mentoriasCerradas"
              :mentor="mentoria"
              :key="mentoria.mentoria_id"
              @refrescar="refrescar"
            ></MentoriasCerradasListaItem>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store'
import BaseNotification2 from '../components/BaseNotification2'
import MentoriasAbiertasListaItem from '../components/MentoriasAbiertasListaItem'
import MentoriasCerradasListaItem from '../components/MentoriasCerradasListaItem'
import mentorService from '../services/mentor'
import BaseLoader from '../components/BaseLoader.vue'
export default {
  name: 'Mentorias',
  components: {
    BaseNotification2,
    MentoriasAbiertasListaItem,
    MentoriasCerradasListaItem,
    BaseLoader
  },
  data: function () {
    return {
      cargando: false,
      cargando2: false,
      mentoriasAbiertas: [],
      mentoriasCerradas: [],
      user: {
        persona_id: JSON.parse(localStorage.getItem('userData')).persona_id
      },
      store
    }
  },
  methods: {
    borrarNotificacion () {
      this.store.setStatus({
        msg: null,
        type: null,
        title: null
      })
    },
    refrescar () {
      mentorService
        .traerMentoriasAbiertasPorPersonaId(this.user.persona_id)
        .then(respuesta => {
          this.cargando = false
          this.mentoriasAbiertas = respuesta
          console.log('Mentorias Abiertas:', respuesta)
        })
      mentorService
        .traerMentoriasCerradasPorPersonaId(this.user.persona_id)
        .then(respuesta => {
          this.cargando2 = false
          this.mentoriasCerradas = respuesta
          console.log('Mentorias Cerradas:', respuesta)
        })
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.borrarNotificacion()
    }, 4000)
    this.cargando = true
    this.cargando2 = true
    mentorService
      .traerMentoriasAbiertasPorPersonaId(this.user.persona_id)
      .then(respuesta => {
        this.cargando = false
        this.mentoriasAbiertas = respuesta
        console.log('Mentorias Abiertas:', respuesta)
      })
    mentorService
      .traerMentoriasCerradasPorPersonaId(this.user.persona_id)
      .then(respuesta => {
        this.cargando2 = false
        this.mentoriasCerradas = respuesta
        console.log('Mentorias Cerradas:', respuesta)
      })
  }
}
</script>

<style>

</style>
